<template>
    <section class="l-section l-section--main o-cart">
        <div class="l-container l-container--main" v-if="customer">
            <cart-tabs />
            <div v-if="externalSupplier" class="l-row">
                <div class="l-row__column o-cart__message">
                    <article
                        class="o-notifications__notification o-notifications__notification--danger"
                    >
                        <div
                            class="o-notifications__notificationBody o-cart__messageText"
                        >
                            <p>{{ externalSupplierMessage }}</p>
                        </div>
                    </article>
                </div>
            </div>
            <div class="l-row">
                <div class="l-row__column l-row__column--10">
                    <cart-week />
                </div>
                <div class="l-row__column o-cart__featured">
                    <featured-products />
                </div>
            </div>
            <div class="l-row">
                <div class="l-row__column l-row__column--10">
                    <cart-summary />
                </div>
            </div>
            <products-modal />
        </div>
    </section>
</template>

<script>
import CartWeek from '@/components/CartWeek'
import ProductsModal from '@/components/ProductsModal'
import CartSummary from '@/components/CartSummary'
import CartTabs from '@/components/CartTabs'
import FeaturedProducts from '@/components/FeaturedProducts'

export default {
    components: {
        CartWeek,
        ProductsModal,
        CartSummary,
        CartTabs,
        FeaturedProducts
    },
    metaInfo: {
        title: 'Koszyk'
    },
    computed: {
        currentAddress() {
            return this.$store.getters.currentAddress
        },
        customer() {
            return this.$store.getters.customer
        },
        currentAddressId() {
            return this.$store.getters.currentAddressId
        },
        currentWarehouseId() {
            const warehouse = this.$store.getters.customerAddressField(
                this.currentAddressId,
                'warehouse'
            )
            if (typeof warehouse === 'object') {
                return Object.prototype.hasOwnProperty.call(warehouse, 'id')
                    ? warehouse.id
                    : false
            } else {
                return false
            }
        },
        currentCompanySize() {
            return this.$store.getters.customerAddressField(
                this.currentAddressId,
                'companySize'
            )
        },
        externalSupplier() {
            const warehouse = this.$store.getters.customerAddressField(
                this.currentAddressId,
                'warehouse'
            )
            if (warehouse) {
                return warehouse.external_supplier ? 1 : 0
            } else {
                return 0
            }
        },
        externalSupplierMessage() {
            return this.$store.getters.externalSupplierMessage
        },
        customerAddresses() {
            return this.$store.getters.customerAddresses
        },
        warehouseId() {
            return this.$store.getters.customerAddressWarehouseId(this.currentAddressId)
        }
    },
    watch: {
        currentAddressId() {
            this.fetchAddressAttrs()
            this.fetchSettings()
        }
    },
    methods: {
        fetchAddressAttrs() {
            this.$store.dispatch('fetchPricelists').then(() => {
                if (typeof this.currentWarehouseId === 'number') {
                    const customerAddress = this.customerAddresses[
                        this.currentAddressId
                    ]
                    const warehouseId = this.currentWarehouseId
                    const externalSupplier = customerAddress.warehouse
                        .external_supplier
                        ? 1
                        : 0
                    const companySize = customerAddress.companySize
                    this.$store.dispatch('fetchPackageCategories', {
                        warehouseId: warehouseId,
                        externalSupplier: externalSupplier
                    })
                    this.$store.dispatch('fetchPackages', {
                        warehouseId: warehouseId,
                        externalSupplier: externalSupplier
                    })
                    this.$store.dispatch('fetchFeaturedPackages', {
                        warehouseId: warehouseId,
                        companySize: companySize,
                        externalSupplier: externalSupplier
                    })
                }
            })
        },
        handleResize() {
            // on touch redirect to nested route
            if (window.innerWidth <= 1024) {
                this.$router.push({ name: 'cart-mobile-summary' })
            }
        },
        fetchSettings() {
            this.$store.dispatch('fetchSettings').then(() => {
                this.$store.dispatch('checkMinimumCartDate')
            })
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
        this.$store.dispatch('fetchPricelists').then(() => {
            if (typeof this.currentWarehouseId === 'number') {
                for (const customerAddress of this.customerAddresses) {
                    const warehouseId = customerAddress.warehouse.id
                    const externalSupplier = customerAddress.warehouse
                        .external_supplier
                        ? 1
                        : 0
                    const companySize = customerAddress.companySize
                    this.$store.dispatch('fetchPackageCategories', {
                        warehouseId: warehouseId,
                        externalSupplier: externalSupplier
                    })
                    this.$store
                        .dispatch('fetchPackages', {
                            warehouseId: warehouseId,
                            externalSupplier
                        })
                        .then(() => {
                            // Open day from params
                            if (this.$route.params && this.$route.params.day) {
                                this.$store.dispatch('modalShow', {
                                    name: 'products',
                                    payload: {
                                        dayInWeek: this.$route.params.day,
                                        addressId: this.currentAddressId,
                                        warehouseId: this.warehouseId,
                                        externalSupplier
                                    }
                                })
                            }
                        })
                    this.$store.dispatch('fetchFeaturedPackages', {
                        warehouseId: warehouseId,
                        companySize: companySize,
                        externalSupplier: externalSupplier
                    })
                }
                this.$store.dispatch('fetchDiscountCategories')
                this.$store.dispatch('fetchDiscounts')
                this.fetchSettings()
            }
        })
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>
